import React from "react";
import { NavBar } from "@/components/NavBar";
import { MobileTabBar } from "@/components/MobileTabBar";
import { GlobalCreateFab } from "@/components/ui/GlobalCreateFab";

export const DomainLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mx-auto min-h-screen app-domain-shell">
      <NavBar />
      {children}
      <GlobalCreateFab />
      <MobileTabBar />
    </div>
  );
};
